import {Component, EventEmitter, Inject, Input} from '@angular/core';
import {HelpModel} from '@spout/global-web/models';
import {Observable, Subject} from 'rxjs';
import {CONTAINER_DATA, ContentModel} from '../content.model';

@Component({
  selector: 'spt-help-manual-latency-correction',
  templateUrl: './help-manual-latency-correction.component.html',
  styleUrls: ['./help-manual-latency-correction.component.scss']
})
export class HelpManualLatencyCorrectionComponent implements ContentModel {
  static ref = HelpModel.MANUAL_LATENCY_CORRECTION;
  static title = 'Manual Latency Correction';

  showBackHeader = true;

  helpTitle = HelpManualLatencyCorrectionComponent.title;

  private modalClose: Subject<any> = new Subject();

  onModalClose(): Observable<any> {
    return this.modalClose.asObservable();
  }

  constructor(@Inject(CONTAINER_DATA) private data: ContentModel) {
    if (this.data) {
      this.showBackHeader = this.data.showBackHeader;
    }
  }

  closeModal() {
    this.modalClose.next(null);
    this.modalClose.complete();
  }
}
